import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import paymentLogos from '@/assets/images/payment-logos.png';
type PaymentFormTypeProps = {
  setPaymentType: (paymentType: 'stripe' | 'paypal') => void;
  paymentType: 'stripe' | 'paypal';
};
export function PaymentFormType(t0) {
  const $ = _c(24);
  const {
    setPaymentType,
    paymentType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-10 text-center"><p className="font-semibold text-xl uppercase tracking-[0.02rem]">Choose payment type</p><p className="text-xs tracking-[0.02rem]">All major credit cards and PayPal accepted</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="block text-xs uppercase tracking-[0.02rem]">Payment Type</span>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = paymentType === "stripe";
  let t4;
  if ($[2] !== setPaymentType) {
    t4 = () => setPaymentType("stripe");
    $[2] = setPaymentType;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <input id="payment-type-stripe" type="radio" name="payment-type" value="stripe" checked={t3} onChange={t4} />;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <label className="ml-2" htmlFor="payment-type-stripe">{"Credit Cards & More"}</label>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5) {
    t7 = <fieldset>{t5}{t6}</fieldset>;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Image src={paymentLogos} alt="Payment Logos" width={330} height={24} className="w-full max-w-[330px] max-[640px]:mb-2" sizes="(max-width: 640px) 100vw, 330px" />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7) {
    t9 = <div className="grid grid-flow-col justify-start gap-3 max-[640px]:grid-flow-row max-[640px]:gap-0">{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = paymentType === "paypal";
  let t11;
  if ($[13] !== setPaymentType) {
    t11 = () => setPaymentType("paypal");
    $[13] = setPaymentType;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <input id="payment-type-paypal" type="radio" name="payment-type" value="paypal" checked={t10} onChange={t11} />;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <label className="ml-2" htmlFor="payment-type-paypal">PayPal</label>;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t12) {
    t14 = <fieldset>{t12}{t13}</fieldset>;
    $[19] = t12;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t14 || $[22] !== t9) {
    t15 = <div>{t1}<div className="grid grid-cols-[250px_1fr] gap-8 border-christ-gray-400 border-t border-b py-6 max-[1024px]:grid-cols-[140px_1fr] max-[640px]:grid-cols-1 max-[1024px]:gap-4 max-[640px]:gap-3">{t2}<div className="font-semibold text-lg">{t9}{t14}</div></div></div>;
    $[21] = t14;
    $[22] = t9;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  return t15;
}